/** If sessionStorage.mockGovDeliveryOutage is `true`, will return query params to trigger mock
 * GovDelivery error from SLS */
export const mockGovDeliveryUrlFailParams = () => {
    const shouldSendMockGovDeliveryError = sessionStorage.getItem('mockGovDeliveryOutage') === 'true';
    return shouldSendMockGovDeliveryError ?  '?mockGovDeliveryOutage=true' : '';
}